// components/ConfirmDialog.jsx
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from '@mui/material';

const ConfirmDialog = ({ open, title, content, projectName, onClose }) => {
  const [input, setInput] = useState('');

  useEffect(() => {
    if (!open) setInput('');
  }, [open]);

  const isMatch =
    projectName &&
    input.trim().toLowerCase() === projectName.toString().toLowerCase();


  return (
    <Dialog open={open} onClose={() => onClose(false)} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography mb={2}>{content}</Typography>
        <Typography variant="body2" color="textSecondary" mb={1}>
          Please type <strong>{projectName}</strong> to confirm.
        </Typography>
        <TextField
          fullWidth
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Enter project name"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>Cancel</Button>
        <Button
          color="error"
          variant="contained"
          onClick={() => onClose(true)}
          disabled={!isMatch}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
